<div class="inner-container" id="innerContainer">
    <div class="py-3 text-base">
        @if (actionData()?.additional?.errorMessage) {
            <div class="error-message">
                <span class="font-bold">Error: </span>{{actionData()?.additional?.errorMessage}}
            </div>
        }
    </div>
    <div class="body">
        <div class="body-container">
            <table class="table-fixed border-collapse border border-slate-400 w-full">
                <tbody>
                    <tr>
                        <td>Reference Number</td>
                        <td>{{actionData()?.additional?.referenceNumber}}</td>
                    </tr>
                    <tr>
                        <td>Company Name</td>
                        <td>{{actionData()?.additional?.companyName}}</td>
                    </tr>
                    <tr>
                        <td>Action ID</td>
                        <td>{{actionData()?.action_Id}}</td>
                    </tr>
                    @if (actionData()?.additional?.branchName) {
                        <tr>
                            <td>Branch</td>
                            <td>{{actionData()?.additional?.branchName}}</td>
                        </tr>
                    }
                    <tr>
                        <td>Date and Time</td>
                        <td>{{formatDateTime(actionData()?.occuredDateTime)}}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td [ngClass]="{'text-green-600': isResolved(), 'text-red-500': !isResolved()}">
                            @if (isResolved()) {
                                Resolved
                            } @else {
                                Action Required
                            }
                        </td>
                    </tr>
                    @if (savedCustomerId()) {
                        <tr>
                            <td>Customer ID</td>
                            <td class="font-bold">{{savedCustomerId()}}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        @if (!isResolved()) {
            <div class="resolve-container">
                <div class="title">Resolve with Customer ID</div>
                <div class="resolve-input">
                    <label for="customerId" class="block mb-2 text-sm font-medium text-slate-600 label">Customer ID</label>
                    <div class="input-wrap">
                        <input type="text" id="customerId" class="refined-input"
                            placeholder="Enter Baseplan Customer ID"
                            [ngModel]="customerId()"
                            (ngModelChange)="customerId.set($event)" />
                    </div>
                </div>
                <div class="actions">
                    <button class="btn btn-resolve" (click)="onResolveClick()" [disabled]="submitting()">
                        @if (submitting()) {
                            Resolving...
                        } @else {
                            Resolve
                        }
                    </button>
                </div>
            </div>
        }
    </div>
</div>
